import {defineStore} from 'pinia'
import axios from 'axios';

export const useUserStore = defineStore({
  id: 'user',

  state: () => ({

    promoProvodVisibility: true,
    promoProvodHide: false,
    loading: false,
    
    userNotification: '',

    userName: '',
    userSurname: '',
    userEmail: '',
    userPhone: '+7',
    userPosition: '',

    userPktToken: '',
    userEngageToken: '',

    userCurrentQuizPage: 1,
    userQuizVisibility: true,

    userQuestion1: '',
    userQuestion2: '',
    userQuestion3: '',
    userQuestion4: '',
    userQuestion5: '',
    userQuestion6: '',
    userQuestion7: '',
    userQuestion8: '',
    userQuestion9: '',
    userQuestion10: '',
    userQuestion11: '',
    userQuestion12: '',
    userQuestion13: '',
    userQuestion14: '',
    userQuestion15: '',
    userQuestion16: '',
    userQuestion17: '',
    userQuestion18: '',
    userQuestion19: '',
    userQuestion20: '10',
    userQuestion21: '',
    userQuestion22: '',
    userQuestion23: '',
    userQuestion24: '',
    userQuestion25: '',
    userQuestion26: '',
    userQuestion27: '',
    userQuestion28: '',
    userQuestion29: '',
    userQuestion30: '',
    userQuestion31: '',
    userQuestion32: '',
    userQuestion33: '',
    userQuestion34: '',
    userQuestion35: '',
    userQuestion36: '',
    userQuestion37: '',
    userQuestion38: '',
    userQuestion39: '',
    userQuestion40: '',
    userQuestion41: '',
    userQuestion42: '',
    userQuestion43: '',
    userQuestion44: '',
    userQuestion45: '',
    userQuestion46: '',
    userQuestion47: '',
    userQuestion48: '',
    userQuestion49: ''
  }),
  getters: {
    //для рассчетов отображения - скорее всего не надо, если только обработать данные для запроса
  },
  actions: {
    //Сброс значений после перезагрузки страницы
    setDefaultUser() {
      this.userNotification = '',
      this.userName = '',
      this.userSurname = '',
      this.userEmail = '',
      this.userPhone = '+7',
      this.userPosition = ''
    },
    //Регистрация
    async signUpUser() {
      this.loading = true;
      try {
        const response = await axios.post('https://platform.promo-kit.ru/api/v1/participants', {
          engage: {
            'project_id': process.env.VUE_APP_PROJECT_ID, 
            'env': process.env.VUE_APP_ENV,
          },
          'duplicate_attributes_to_engage': true,
          participant: {
            'first_name': this.userName,
            'last_name': this.userSurname,
            'phone': this.userPhone,
            'email': this.userEmail,
            'password': 'Aa123456',
            'password_confirmation': 'Aa123456',
            fields: {
              'position': this.userPosition
            }
          }
        });
        console.log(response.data)
        if (response.data.status == 'success') {
          this.signInUser();
        }
      } catch(e) {
        let message = e.response.data.message;
        if (message == 'Вы уже зарегистрированы, пожалуйста авторизуйтесь.' || message == 'Email уже подтверждён. Пожалуйста, попробуйте войти в систему' || message == 'Данный email уже зарегистрирован, пожалуйста, войдите в свой аккаунт.') {
          this.signInUser();
        } else {
          console.error('Внимание! ' + message);
          this.userNotification = 'Произошла какая-то ошибка. Попробуйте позднее.';
          document.querySelector('#openNotification').dispatchEvent(new Event('click'));
          this.loading = false;
        }
      } finally {

      }
    },
    async signInUser() {
      try {
        const response = await axios.post('https://platform.promo-kit.ru/api/v4/participants/sign_in', {
          'login': this.userEmail,
          'password': 'Aa123456',
        }, {
          headers: {
            'Api-Key': process.env.VUE_APP_API_KEY
          }
        });
        console.log(response.data);
        this.userPktToken = response.data.token;
        this.userEngageToken = response.data.engage.token;
        console.log(response.data.participant.page1)
        this.updateFields(['page1'], ['true']);
        if (response.data.participant.page6 == 'true') {
          this.userQuizVisibility = false;
        } else if (response.data.participant.page5 == 'true') {
          this.userCurrentQuizPage = 6;
        } else if (response.data.participant.page4 == 'true') {
          this.userCurrentQuizPage = 5;
        } else if (response.data.participant.page3 == 'true') {
          this.userCurrentQuizPage = 4;
        } else if (response.data.participant.page2 == 'true') {
          this.userCurrentQuizPage = 3;
        }
        this.loading = false;
        this.userNotification = '<p>Прежде чем вы потратите время на заполнение данной анкеты, убедитесь, что вы понимаете цели данного исследования правильно. Дело в том, что мы хотели бы получить ответы от специалистов, непосредственно связанных с маркетингом и цифровой трансформацией в сфере Retail/FMCG.</p><p>В противном случае, мы вынуждены будем игнорировать ваши ответы, а это значит, что время с обеих сторон будет потрачено зря.</p><p>По этой причине мы принимаем регистрацию только с корпоративных почтовых адресов (домен должен принадлежать вашей компании).</p><p>В благодарность за соблюдение этой небольшой формальности, мы сделаем вашей компании предложение, которое невозможно получить с такими условиями где-либо на рынке.</p><p>Мы ожидаем, что ваша компания — ритейлер, производитель или рекламное агентство, непосредственно связанное с запуском цифровых промо. Вы — бренд-менеджер, менеджер проектов, сотрудник отдела маркетинга, менеджер цифровой трансформации, руководитель отдела или руководитель организации.</p><p>Вы можете иметь близкую к вышеназванным должность, самое главное — вы должны подойти нам как источник ценной информации, основанной на вашем личном опыте проведения промо, которую мы используем для развития продукта.</p>';
        document.querySelector('#openNotification').dispatchEvent(new Event('click'));
      } catch(e) {
        console.log('Ошибка авторизации');
        //console.log(e);
        this.loading = false;
        this.userPktToken == '';
        this.userEngageToken == '';
        this.userCurrentQuizPage = 1;
        this.userQuizVisibility = true;
      } finally {

      }
    },
    async updateFields(fieldNameArray, valueArray) {
      let engage = {fields: {}};
      for (var i = 0; i < fieldNameArray.length; i++) {
        engage.fields[fieldNameArray[i]] = valueArray[i];
      }
      try {
        const response = await axios.put('https://platform.promo-kit.ru/api/v4/engages', {
          engage
        }, {
          headers: {
            Authorization: 'Token ' + this.userEngageToken,
            'Api-Key': process.env.VUE_APP_API_KEY
          }
        });
        console.log(response.data);
        this.loading = false;
      } catch(e) {
        console.log('Ошибка обновления поля');
        console.log(e);
      } finally {

      }
    },
    async refreshProfileData() {
      try {
        const response = await axios.get('https://platform.promo-kit.ru/api/v1/participants', { 
          params: {
            engage: {
              'project_id': process.env.VUE_APP_PROJECT_ID, 
              'env': process.env.VUE_APP_ENV,
            }
          },
          headers: {
            'Authorization': `Token ${this.userPktToken}`,
          }
        });
        //console.log(response.data);
        if (response.data.participant.page6 == 'true') {
          this.userQuizVisibility = false;
        } else if (response.data.participant.page5 == 'true') {
          this.userCurrentQuizPage = 6;
        } else if (response.data.participant.page4 == 'true') {
          this.userCurrentQuizPage = 5;
        } else if (response.data.participant.page3 == 'true') {
          this.userCurrentQuizPage = 4;
        } else if (response.data.participant.page2 == 'true') {
          this.userCurrentQuizPage = 3;
        }
      } catch(e) {
        console.log('Ошибка рефреша');
        //console.log(e);
        this.userPktToken = '';
        this.userEngageToken = '';
        this.userCurrentQuizPage = 1;
        this.userQuizVisibility = true;
      } finally {

      }
    }
  },
  persist: {
    storage: localStorage
  }
})